import useSiteSettings from "@/hooks/useSiteSettings";

export default function Footer() {
  const { settings } = useSiteSettings();
  const f = settings.footer;

  return (
    <footer
      data-testid="footer"
      className="bg-[#3D2E1C] text-[#FDF9F3] py-12 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-2xl font-bold text-[#FDF9F3]">Overdrive</span>
            <span className="font-hand text-xl text-[#D6B98D]">auto spa</span>
          </div>
          <p data-testid="footer-description" className="text-sm text-[#FDF9F3]/60 mt-2 max-w-md">
            {f.description}
          </p>
          <p className="text-xs text-[#D6B98D] mt-3 font-medium">
            🚗 Run by Portland teens · locally owned & operated
          </p>
        </div>

        <div className="flex flex-wrap gap-6 text-sm font-medium text-[#FDF9F3]/60">
          <a href="#packages" className="hover:text-[#D6B98D] transition-colors">Packages</a>
          <a href="#booking" className="hover:text-[#D6B98D] transition-colors">Book</a>
          <a href="#gallery" className="hover:text-[#D6B98D] transition-colors">Gallery</a>
          <a href="#contact" className="hover:text-[#D6B98D] transition-colors">Contact</a>
        </div>

        <div data-testid="footer-copyright" className="text-xs text-[#FDF9F3]/40">
          © {new Date().getFullYear()} {f.copyright_name}
        </div>
      </div>
    </footer>
  );
}
